import React from "react";
import styles from './Footer.module.css';
import { footer, logoBiro } from "../../assets/images";

function Footer() {
  return <div
    className={styles.footer}
    style={{
      backgroundImage: `url(${footer})`,
    }}>
    <div style={{ display: 'flex' }}>
      <img width={60} height={70} style={{ margin: '0px 8px' }} src={logoBiro} alt="Biro BIA" />
      <div className={styles.footerText}>

        <div>
          <span >
            <b>Biro BUMD, Investasi dan Administrasi Pembangunan Provinsi Jawa Barat</b>
          </span>
          <br />
          <span>
            Jl Sangkuriang No.2, Dago, Kecamatan Coblong, Kota Bandung, Jawa Barat 40135
          </span>
        </div>
      </div>
    </div>
    <div style={{
      height: '20px',
      marginTop: "32px"
    }}>
    </div>
    <div className={styles.copyright}>
      <b>Copyright 2023</b>
    </div>
  </div>;
}

export default Footer;
